import { motion } from "motion/react"
import { RegisterState } from "../actions/register"
import { CountryField, EmailField, FullNameField } from "./IndividualSubForm"
import { ErrorMessage, Field, Label } from "@ui/fieldset"
import { Input } from "@ui/input"

interface Props {
    countries:
        | {
              value: string
              label: string
          }[]
        | undefined
    formState: RegisterState
}

export function CompanyNameField({ formState }: { formState: RegisterState }) {
    return (
        <Field className="col-span-full">
            <Label>Company name</Label>
            <Input
                name="company_name"
                autoComplete="organization organization-name"
                invalid={Array.isArray(formState.errors?.companyName) && formState.errors.companyName.length > 0}
                required
            />
            {formState.errors?.companyName && (
                <ErrorMessage>
                    {formState.errors.companyName.map((error) => (
                        <p key={error}>{error}</p>
                    ))}
                </ErrorMessage>
            )}
        </Field>
    )
}

export function OrganizationSubForm({ countries, formState }: Props) {
    return (
        <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.3 }}
        >
            <div className="grid grid-cols-1 gap-6">
                <FullNameField formState={formState} />
                <EmailField formState={formState} />
                <CompanyNameField formState={formState} />
                <CountryField countries={countries} formState={formState} />
            </div>
        </motion.div>
    )
}
